// src/scenes/dashboard/config/series.js

// 🔹 OPTICHILLER 2COMP
export const optichillerSeriesDefs = [
  { key: "presionSuccionComp1", label: "Pres. Succión Compresor 1", color: "#1e88e5" },
  { key: "presionSuccionComp2", label: "Pres. Succión Compresor 2", color: "#8e24aa" },
  { key: "tempProcesoEntrada",  label: "Temp. Proceso Entrada",     color: "#ff9800" },
  { key: "tempProcesoSalida",   label: "Temp. Proceso Salida",      color: "#4caf50" },
  { key: "tempTorreEntrada",    label: "Temp. Torre Entrada",       color: "#f44336" },
  { key: "tempTorreSalida",     label: "Temp. Torre Salida",        color: "#00bcd4" },
  { key: "tempDescargaComp1",   label: "Temp. Descarga Comp. 1",    color: "#795548" },
  { key: "tempDescargaComp2",   label: "Temp. Descarga Comp. 2",    color: "#607d8b" },
  { key: "presionDescargaComp1",label: "Presión Descarga Comp. 1",  color: "#cddc39" },
  { key: "presionDescargaComp2",label: "Presión Descarga Comp. 2",  color: "#e91e63" },
];

// 🔹 CENTRÍFUGA
export const centrifugaSeriesDefs = [
  { key: "tempProcesoEntrada",   label: "Temp Proceso Entrada",        color: "#ff9800" },
  { key: "tempProcesoSalida",    label: "Temp Proceso Salida",         color: "#4caf50" },
  { key: "tempAguaTorreEntrada", label: "Temp Agua Torre Entrada",     color: "#f44336" },
  { key: "tempAguaTorreSalida",  label: "Temp Agua Torre Salida",      color: "#00bcd4" },
  { key: "presAbsolutaSuccion",  label: "Pres Absoluta Succión",       color: "#1976d2" },
  { key: "presAbsolutaDescarga", label: "Pres Absoluta Descarga",      color: "#9c27b0" },
  { key: "tempDescarga",         label: "Temp Descarga",               color: "#795548" },
];

// 🔹 COTHERM 2COMP
export const cotherm2CompSeriesDefs = [
  { key: "tempProcesoEntrada",   label: "Temp. Proceso Entrada",   color: "#ff9800" },
  { key: "tempProcesoSalida",    label: "Temp. Proceso Salida",    color: "#4caf50" },
  { key: "tempEvapSalidaC1",     label: "Temp. Evap Salida C1",    color: "#1976d2" },
  { key: "tempEvapSalidaC2",     label: "Temp. Evap Salida C2",    color: "#9c27b0" },
  { key: "tempDescargaComp1",    label: "Temp. Descarga Comp 1",   color: "#f44336" },
  { key: "tempDescargaComp2",    label: "Temp. Descarga Comp 2",   color: "#795548" },
  { key: "presSuccionComp1",     label: "Pres. Succion Comp 1",    color: "#00bcd4" },
  { key: "presSuccionComp2",     label: "Pres. Succion Comp 2",    color: "#cddc39" },
  { key: "presionDescargaComp1", label: "Presion Descarga Comp 1", color: "#e91e63" },
  { key: "presionDescargaComp2", label: "Presion Descarga Comp 2", color: "#607d8b" },
];

// 🔹 COTHERM 4COMP (lista “base” para filtrar por keys del gauge group)
export const cotherm4CompSeriesDefs = [
  { key: "tempHeladaEntrada",     label: "Temp. Helada Entrada",        color: "#ff9800" },
  { key: "tempHeladaSalida",      label: "Temp. Helada Salida",         color: "#4caf50" },
  { key: "tempCondEntrada",       label: "Temp. Condensación Entrada",  color: "#1976d2" },
  { key: "tempCondSalida",        label: "Temp. Condensación Salida",   color: "#9c27b0" },

  { key: "presSuccionComp1",      label: "Pres. Succion Comp 1",        color: "#f44336" },
  { key: "presSuccionComp2",      label: "Pres. Succion Comp 2",        color: "#00bcd4" },
  { key: "presSuccionComp3",      label: "Pres. Succion Comp 3",        color: "#cddc39" },
  { key: "presSuccionComp4",      label: "Pres. Succion Comp 4",        color: "#e91e63" },

  { key: "presionDescargaComp1",  label: "Presion Descarga Comp 1",     color: "#795548" },
  { key: "presionDescargaComp2",  label: "Presion Descarga Comp 2",     color: "#607d8b" },
  { key: "presionDescargaComp3",  label: "Presion Descarga Comp 3",     color: "#8bc34a" },
  { key: "presionDescargaComp4",  label: "Presion Descarga Comp 4",     color: "#ff5722" },

  { key: "presionDifAceiteComp1", label: "Presion Dif. Aceite Comp 1",  color: "#3f51b5" },
  { key: "presionDifAceiteComp2", label: "Presion Dif. Aceite Comp 2",  color: "#009688" },
  { key: "presionDifAceiteComp3", label: "Presion Dif. Aceite Comp 3",  color: "#673ab7" },
  { key: "presionDifAceiteComp4", label: "Presion Dif. Aceite Comp 4",  color: "#9e9e9e" },
];

// 🔹 COTHERM 4COMP 2CC (por pestañas)
export const cotherm4Comp2CCSeriesDefs = {
  temperaturas: [
    { key: "tempHeladaEntrada",   label: "Temp. Helada Entrada",        color: "#ff9800" },
    { key: "tempHeladaSalida",    label: "Temp. Helada Salida",         color: "#4caf50" },
    { key: "tempCondEntrada",     label: "Temp. Condensación Entrada",  color: "#1976d2" },
    { key: "tempCondSalida",      label: "Temp. Condensación Salida",   color: "#9c27b0" },
    { key: "tempCondSecEntrada",  label: "Temp. Cond. Sec Entrada",     color: "#00bcd4" },
    { key: "tempCondSecSalida",   label: "Temp. Cond. Sec Salida",      color: "#f44336" },
  ],
  succion: [
    { key: "presSuccionComp1", label: "Pres. Succion Comp 1", color: "#f44336" },
    { key: "presSuccionComp2", label: "Pres. Succion Comp 2", color: "#00bcd4" },
    { key: "presSuccionComp3", label: "Pres. Succion Comp 3", color: "#cddc39" },
    { key: "presSuccionComp4", label: "Pres. Succion Comp 4", color: "#e91e63" },
  ],
  descarga: [
    { key: "presionDescargaComp1", label: "Presion Descarga Comp 1", color: "#795548" },
    { key: "presionDescargaComp2", label: "Presion Descarga Comp 2", color: "#607d8b" },
    { key: "presionDescargaComp3", label: "Presion Descarga Comp 3", color: "#8bc34a" },
    { key: "presionDescargaComp4", label: "Presion Descarga Comp 4", color: "#ff5722" },
  ],
  aceite: [
    { key: "presionDifAceiteComp1", label: "Presion Dif. Aceite Comp 1", color: "#3f51b5" },
    { key: "presionDifAceiteComp2", label: "Presion Dif. Aceite Comp 2", color: "#009688" },
    { key: "presionDifAceiteComp3", label: "Presion Dif. Aceite Comp 3", color: "#673ab7" },
    { key: "presionDifAceiteComp4", label: "Presion Dif. Aceite Comp 4", color: "#9e9e9e" },
  ],
};

// 🔹 ezChiller 2Comp CT6
export const ezChiller2CompCT6SeriesDefs = [
  { key: "tempProcesoEntrada",     label: "Temp. Proceso Entrada",          color: "#ff9800" },
  { key: "tempProcesoSalida",      label: "Temp. Proceso Salida",           color: "#4caf50" },
  { key: "tempRefrCondensado1",    label: "Temp. Refr. Condensado C1",      color: "#1976d2" },
  { key: "tempRefrCondensado2",    label: "Temp. Refr. Condensado C2",      color: "#9c27b0" },
  { key: "tempDescargaComp1",      label: "Temp. Descarga Comp 1",          color: "#f44336" },
  { key: "tempDescargaComp2",      label: "Temp. Descarga Comp 2",          color: "#795548" },
  { key: "presionSuccionComp1",    label: "Presión Succión C1",             color: "#00bcd4" },
  { key: "presionSuccionComp2",    label: "Presión Succión C2",             color: "#cddc39" },
  { key: "presionDescargaComp1",   label: "Presión Descarga C1",            color: "#e91e63" },
  { key: "presionDescargaComp2",   label: "Presión Descarga C2",            color: "#607d8b" },
];

// 🔹 FSC (por view)
export const fscSeriesByView = { 
  temperaturas: [
    // Proceso
    { key: "tempProcesoEntrada", label: "Temp. Proceso Entrada", color: "#ff9800" },
    { key: "tempProcesoSalida",  label: "Temp. Proceso Salida",  color: "#4caf50" },

    // M1
    { key: "m1TempEvapSalida", label: "M1 Temp. Evap Salida", color: "#1976d2" },
    { key: "m1TempDescarga",   label: "M1 Temp. Descarga",   color: "#9c27b0" },

    // M2
    { key: "m2TempEvapSalida", label: "M2 Temp. Evap Salida", color: "#795548" },
    { key: "m2TempDescarga",   label: "M2 Temp. Descarga",   color: "#607d8b" },

    // M3
    { key: "m3TempEvapSalida", label: "M3 Temp. Evap Salida", color: "#8bc34a" },
    { key: "m3TempDescarga",   label: "M3 Temp. Descarga",   color: "#ff5722" },

    // M4
    { key: "m4TempEvapSalida", label: "M4 Temp. Evap Salida", color: "#673ab7" },
    { key: "m4TempDescarga",   label: "M4 Temp. Descarga",   color: "#9e9e9e" },

    // M5
    { key: "m5TempEvapSalida", label: "M5 Temp. Evap Salida", color: "#4caf50" },
    { key: "m5TempDescarga",   label: "M5 Temp. Descarga",   color: "#f44336" },

    // M6
    { key: "m6TempEvapSalida", label: "M6 Temp. Evap Salida", color: "#795548" },
    { key: "m6TempDescarga",   label: "M6 Temp. Descarga",   color: "#607d8b" },

    // M7
    { key: "m7TempEvapSalida", label: "M7 Temp. Evap Salida", color: "#8bc34a" },
    { key: "m7TempDescarga",   label: "M7 Temp. Descarga",   color: "#ff5722" },

    // M8
    { key: "m8TempEvapSalida", label: "M8 Temp. Evap Salida", color: "#673ab7" },
    { key: "m8TempDescarga",   label: "M8 Temp. Descarga",   color: "#9e9e9e" },

    // M9
    { key: "m9TempEvapSalida", label: "M9 Temp. Evap Salida", color: "#4caf50" },
    { key: "m9TempDescarga",   label: "M9 Temp. Descarga",   color: "#f44336" },

    // M10
    { key: "m10TempEvapSalida", label: "M10 Temp. Evap Salida", color: "#795548" },
    { key: "m10TempDescarga",   label: "M10 Temp. Descarga",   color: "#607d8b" },
  ],

  presiones: [
    // M1
    { key: "m1PresSuccion",  label: "M1 Pres. Succión",  color: "#00bcd4" },
    { key: "m1PresDescarga", label: "M1 Pres. Descarga", color: "#f44336" },

    // M2
    { key: "m2PresSuccion",  label: "M2 Pres. Succión",  color: "#cddc39" },
    { key: "m2PresDescarga", label: "M2 Pres. Descarga", color: "#e91e63" },

    // M3
    { key: "m3PresSuccion",  label: "M3 Pres. Succión",  color: "#3f51b5" },
    { key: "m3PresDescarga", label: "M3 Pres. Descarga", color: "#009688" },

    // M4
    { key: "m4PresSuccion",  label: "M4 Pres. Succión",  color: "#2196f3" },
    { key: "m4PresDescarga", label: "M4 Pres. Descarga", color: "#ff9800" },

    // M5
    { key: "m5PresSuccion",  label: "M5 Pres. Succión",  color: "#00bcd4" },
    { key: "m5PresDescarga", label: "M5 Pres. Descarga", color: "#9c27b0" },

    // M6
    { key: "m6PresSuccion",  label: "M6 Pres. Succión",  color: "#cddc39" },
    { key: "m6PresDescarga", label: "M6 Pres. Descarga", color: "#e91e63" },

    // M7
    { key: "m7PresSuccion",  label: "M7 Pres. Succión",  color: "#3f51b5" },
    { key: "m7PresDescarga", label: "M7 Pres. Descarga", color: "#009688" },

    // M8
    { key: "m8PresSuccion",  label: "M8 Pres. Succión",  color: "#2196f3" },
    { key: "m8PresDescarga", label: "M8 Pres. Descarga", color: "#ff9800" },

    // M9
    { key: "m9PresSuccion",  label: "M9 Pres. Succión",  color: "#00bcd4" },
    { key: "m9PresDescarga", label: "M9 Pres. Descarga", color: "#9c27b0" },

    // M10
    { key: "m10PresSuccion",  label: "M10 Pres. Succión",  color: "#cddc39" },
    { key: "m10PresDescarga", label: "M10 Pres. Descarga", color: "#e91e63" },
  ],
};

// 🔹 FSC UNICO
export const fscUnicoSeriesDefs = [
  { key: "tempEvapEnt",   label: "Temp. Evap Entrada",   color: "#ff9800" },
  { key: "tempEvapSal",   label: "Temp. Evap Salida",    color: "#4caf50" },
  { key: "tempSuccionC1", label: "Temp. Succión C1",     color: "#1976d2" },
  { key: "tempSuccionC2", label: "Temp. Succión C2",     color: "#9c27b0" },

  { key: "presSuccionC1", label: "Pres. Succión C1",     color: "#00bcd4" },
  { key: "presSuccionC2", label: "Pres. Succión C2",     color: "#cddc39" },
  { key: "presDescargaC1",label: "Pres. Descarga C1",    color: "#f44336" },
  { key: "presDescargaC2",label: "Pres. Descarga C2",    color: "#e91e63" },

  { key: "superheatC1",   label: "Superheat C1",         color: "#795548" },
  { key: "superheatC2",   label: "Superheat C2",         color: "#607d8b" },
];

// 🔹 FSC V3 (por view)
export const fscV3SeriesByView = { 
  temperaturas: [
    { key: "tempProcesoEntrada", label: "Temp. Proceso Entrada", color: "#ff9800" },
    { key: "tempProcesoSalida",  label: "Temp. Proceso Salida",  color: "#4caf50" },

    { key: "m1TempEvapSalida",  label: "M1 Temp. Evap Salida",  color: "#1976d2" },
    { key: "m1TempEvapEntrada", label: "M1 Temp. Evap Entrada", color: "#9c27b0" },

    { key: "m2TempEvapSalida",  label: "M2 Temp. Evap Salida",  color: "#0288d1" },
    { key: "m2TempEvapEntrada", label: "M2 Temp. Evap Entrada", color: "#8e24aa" },

    { key: "m3TempEvapSalida",  label: "M3 Temp. Evap Salida",  color: "#1565c0" },
    { key: "m3TempEvapEntrada", label: "M3 Temp. Evap Entrada", color: "#7b1fa2" },

    { key: "m4TempEvapSalida",  label: "M4 Temp. Evap Salida",  color: "#0d47a1" },
    { key: "m4TempEvapEntrada", label: "M4 Temp. Evap Entrada", color: "#6a1b9a" },

    { key: "m5TempEvapSalida",  label: "M5 Temp. Evap Salida",  color: "#1e88e5" },
    { key: "m5TempEvapEntrada", label: "M5 Temp. Evap Entrada", color: "#ab47bc" },

    { key: "m6TempEvapSalida",  label: "M6 Temp. Evap Salida",  color: "#42a5f5" },
    { key: "m6TempEvapEntrada", label: "M6 Temp. Evap Entrada", color: "#ba68c8" },

    { key: "m7TempEvapSalida",  label: "M7 Temp. Evap Salida",  color: "#64b5f6" },
    { key: "m7TempEvapEntrada", label: "M7 Temp. Evap Entrada", color: "#ce93d8" },

    { key: "m8TempEvapSalida",  label: "M8 Temp. Evap Salida",  color: "#90caf9" },
    { key: "m8TempEvapEntrada", label: "M8 Temp. Evap Entrada", color: "#e1bee7" },

    { key: "m9TempEvapSalida",  label: "M9 Temp. Evap Salida",  color: "#bbdefb" },
    { key: "m9TempEvapEntrada", label: "M9 Temp. Evap Entrada", color: "#f3e5f5" },

    { key: "m10TempEvapSalida",  label: "M10 Temp. Evap Salida",  color: "#e3f2fd" },
    { key: "m10TempEvapEntrada", label: "M10 Temp. Evap Entrada", color: "#fce4ec" },
  ],

  presiones: [
    { key: "m1PresDescC1", label: "M1 Pres. Desc C1", color: "#f44336" },
    { key: "m1PresDescC2", label: "M1 Pres. Desc C2", color: "#00bcd4" },

    { key: "m2PresDescC1", label: "M2 Pres. Desc C1", color: "#e53935" },
    { key: "m2PresDescC2", label: "M2 Pres. Desc C2", color: "#26c6da" },

    { key: "m3PresDescC1", label: "M3 Pres. Desc C1", color: "#d32f2f" },
    { key: "m3PresDescC2", label: "M3 Pres. Desc C2", color: "#4dd0e1" },

    { key: "m4PresDescC1", label: "M4 Pres. Desc C1", color: "#c62828" },
    { key: "m4PresDescC2", label: "M4 Pres. Desc C2", color: "#80deea" },

    { key: "m5PresDescC1", label: "M5 Pres. Desc C1", color: "#b71c1c" },
    { key: "m5PresDescC2", label: "M5 Pres. Desc C2", color: "#b2ebf2" },

    { key: "m6PresDescC1", label: "M6 Pres. Desc C1", color: "#ff5252" },
    { key: "m6PresDescC2", label: "M6 Pres. Desc C2", color: "#18ffff" },

    { key: "m7PresDescC1", label: "M7 Pres. Desc C1", color: "#ff1744" },
    { key: "m7PresDescC2", label: "M7 Pres. Desc C2", color: "#00e5ff" },

    { key: "m8PresDescC1", label: "M8 Pres. Desc C1", color: "#d50000" },
    { key: "m8PresDescC2", label: "M8 Pres. Desc C2", color: "#1de9b6" },

    { key: "m9PresDescC1", label: "M9 Pres. Desc C1", color: "#c51162" },
    { key: "m9PresDescC2", label: "M9 Pres. Desc C2", color: "#64ffda" },

    { key: "m10PresDescC1", label: "M10 Pres. Desc C1", color: "#880e4f" },
    { key: "m10PresDescC2", label: "M10 Pres. Desc C2", color: "#a7ffeb" },
  ],
};

// 🔹 Licuador
export const licuador1CompSeriesDefs = [
  { key: "tempProcesoEntrada", label: "Temp. Proceso Entrada", color: "#ff9800" },
  { key: "tempProcesoSalida",  label: "Temp. Proceso Salida",  color: "#4caf50" },
  { key: "tempCondEntrada",    label: "Temp. Cond Entrada",    color: "#1976d2" },
  { key: "tempCondSalida",     label: "Temp. Cond Salida",     color: "#9c27b0" },
  { key: "tempDescarga",       label: "Temp. Descarga",        color: "#f44336" },
  { key: "tempRefrEvap",       label: "Temp. Refr Evap",       color: "#00bcd4" },
  { key: "presSuccion",        label: "Pres. Succión",         color: "#795548" },
  { key: "presDescarga",       label: "Pres. Descarga",        color: "#607d8b" },
];

// 🔹 Optichiller CT6
export const optichillerCT6SeriesDefs = [ 
  { key: "presSuccionComp1",     label: "Pres. Succión C1",        color: "#00bcd4" },
  { key: "presSuccionComp2",     label: "Pres. Succión C2",        color: "#cddc39" },
  { key: "presionDescargaComp1", label: "Pres. Descarga C1",       color: "#e91e63" },
  { key: "presionDescargaComp2", label: "Pres. Descarga C2",       color: "#607d8b" },
  { key: "tempProcesoEntrada",   label: "Temp. Proceso Entrada",   color: "#ff9800" },
  { key: "tempProcesoSalida",    label: "Temp. Proceso Salida",    color: "#4caf50" },
  { key: "tempTorreEntrada",     label: "Temp. Torre Entrada",     color: "#f44336" },
  { key: "tempTorreSalida",      label: "Temp. Torre Salida",      color: "#00bcd4" },
  { key: "tempDescargaComp1",    label: "Temp. Descarga C1",       color: "#f44336" },
  { key: "tempDescargaComp2",    label: "Temp. Descarga C2",       color: "#795548" },
];
// 🔹 Optichiller 1Comp
export const optichiller1CompSeriesDefs = [
  { key: "presionSuccionComp1",   label: "Presión Succión Comp. 1",    color: "#00bcd4" },
  { key: "presionDescargaComp1",  label: "Presión Descarga Comp. 1",   color: "#e91e63" },
  { key: "tempProcesoEntrada",    label: "Temp. Proceso Entrada",      color: "#ff9800" },
  { key: "tempProcesoSalida",     label: "Temp. Proceso Salida",       color: "#4caf50" },
  { key: "tempTorreEntrada",      label: "Temp. Torre Entrada",        color: "#f44336" },
  { key: "tempTorreSalida",       label: "Temp. Torre Salida",         color: "#1976d2" },
  { key: "tempDescargaComp1",     label: "Temp. Descarga Compresor 1",  color: "#795548" },
];

// 🔹 Optichiller 1Comp CT6
export const optichiller1CompCT6SeriesDefs = [
  { key: "tempProcesoEntrada",  label: "Temp. Proceso Entrada",       color: "#ff9800" },
  { key: "tempProcesoSalida",   label: "Temp. Proceso Salida",        color: "#4caf50" },
  { key: "tempTorreEntrada",    label: "Temp. Torre Entrada",         color: "#f44336" },
  { key: "tempTorreSalida",     label: "Temp. Torre Salida",          color: "#1976d2" },
  { key: "tempDescargaComp1",   label: "Temp. Descarga Compresor 1",  color: "#795548" },
  { key: "presSuccionComp1",    label: "Presion Succion Comp 1",      color: "#00bcd4" },
  { key: "presDescargaComp1",   label: "Presion Descarga Comp 1",     color: "#e91e63" },
];

// 🔹 Victex 1Comp
export const victex1CompSeriesDefs = [
  { key: "tempProcesoEntrada", label: "Temp. Proceso Entrada", color: "#ff9800" },
  { key: "tempProcesoSalida",  label: "Temp. Proceso Salida",  color: "#4caf50" },
  { key: "tempDescarga",       label: "Temp. Descarga",        color: "#f44336" },
  { key: "tempAmbiente",       label: "Temp. Ambiente",        color: "#607d8b" },
  { key: "presionSuccion",     label: "Presión Succión",       color: "#00bcd4" },
  { key: "presionDescarga",    label: "Presión Descarga",      color: "#9c27b0" },
];

// 🔹 FSC V3 1Comp
export const fscV31CompSeriesDefs = [
  { key: "tempEvapSalida",          label: "Temp. Evaporador Salida",   color: "#00bcd4" },
  { key: "tempEvapEntrada",         label: "Temp. Evaporador Entrada",  color: "#cddc39" },
  { key: "presionSuccionComp1",     label: "Pres. Succión C1",          color: "#e91e63" },
  { key: "presionDescargaComp1",    label: "Pres. Descarga C1",         color: "#607d8b" },
  { key: "sobrecalentamientoComp1", label: "Sobrecalentamiento C1",     color: "#ff9800" },
  { key: "tempSuccionComp1",        label: "Temp. Succión C1",          color: "#4caf50" },
];

// 🔹 FSC 1Comp
export const fsc1CompSeriesDefs = [
  { key: "tempEvapSalida",     label: "Temp. Evap. Salida", color: "#00bcd4" },
  { key: "tempDescarga",       label: "Temp. Descarga",     color: "#cddc39" },
  { key: "presionSuccion",     label: "Pres. Succión",      color: "#e91e63" },
  { key: "presionDescarga",    label: "Pres. Descarga",     color: "#607d8b" },
  { key: "sobrecalentamiento", label: "Sobrecalent.",       color: "#ff9800" },
  { key: "tempSuccion",        label: "Temp. Succión",      color: "#4caf50" },
];

// 🔹 FSC V2 1Comp
export const fscV21CompSeriesDefs = [
  { key: "tempEvapSalida",     label: "Temp. Evap. Salida", color: "#00bcd4" },
  { key: "tempDescarga",       label: "Temp. Descarga",     color: "#cddc39" },
  { key: "presionSuccion",     label: "Pres. Succión",      color: "#e91e63" },
  { key: "presionDescarga",    label: "Pres. Descarga",     color: "#607d8b" },
  { key: "sobrecalentamiento", label: "Sobrecalent.",       color: "#ff9800" },
  { key: "tempSuccion",        label: "Temp. Succión",      color: "#4caf50" },
];